interface Props {
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export default function Switch(props: Props) {
  const { checked, onChange } = props;

  return (
    <div className="relative inline-block flex">
      <input
        type="checkbox"
        className="peer appearance-none w-11 h-5 bg-gray-200 rounded-full checked:bg-common-black cursor-pointer transition-colors duration-300"
        checked={checked}
        onChange={onChange}
      />
      <label
        htmlFor="switch-component"
        className="absolute top-0 left-0 w-5 h-5 bg-common-white rounded-full border border-gray-500 shadow-sm transition-transform duration-300 peer-checked:translate-x-6 peer-checked:border-common-black cursor-pointer"
      />
    </div>
  );
}
